import { Component, OnInit } from '@angular/core';
import {HttpItemsService} from '../../services/http/http-items.service';
import {BarChartOrientation, ChartCore} from '@easycomp/easy-charts/lib/definitions/enums';
import {CzechNumberFormatPipe} from '../pipes/czech-number-format.pipe';
import {FilterHandlerService} from '../../services/filter-handler.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit {

  top5: Array<any>;

  sumData = {
    data: [],
    labels: ['Dotace', 'Spoluúčast'],
    colors: [{backgroundColor: ['#5C8FB6', '#bebcc0']}],
    ready: false
  };

  fieldSumData = {
    data: [],
    groups: [],
    ready: false
  };

  fieldCountData = {
    data: [],
    groups: [],
    ready: false
  };

  cityPartSumData = {
    data: [],
    groups: [],
    ready: false
  };

  cityPartCountData = {
    data: [],
    groups: [],
    ready: false
  };

  sumChartOptions = {
    core: ChartCore.JS,
    labelFunction: (sector, data) => {
      return this.sumData.data[sector.index].label;
      // return this.sumData.data[sector.index].label + ' - ' + this.czechNumberPipe.transform(
      //   this.sumData.data[sector.index].value.toFixed(0)
      // )  + ' Kč';
    },
    legendPercentace: true
  };
  fieldSumChartOptions = {
    core: ChartCore.JS,
    labelFunction: (sector, data) => {
      return this.fieldSumData.data[sector.index].label;
      // return this.fieldSumData.data[sector.index].label + ' - ' + this.czechNumberPipe.transform(
      //   this.fieldSumData.data[sector.index].value.toFixed(0)
      // )  + ' Kč';
    },
    legendPercentace: true
  };
  countChartOptions = {
    core: ChartCore.JS,
    labelFunction: (sector, data) => {
      return this.fieldCountData.data[sector.index].label;
      // return this.fieldCountData.data[sector.index].label + ' - ' + this.czechNumberPipe.transform(
      //   this.fieldCountData.data[sector.index].value.toFixed(0)
      // );
    },
    legendPercentace: true
  };
  partSumChartOptions = {
    core: ChartCore.JS,
    orientation: BarChartOrientation.HORIZONTAL,
    labelFunction: (sector, data) => {
      const prefix = sector.datasetIndex === 0 ? 'Dotace' : 'Spoluúčast';
      return prefix + ': ' + this.czechNumberPipe.transform(
        Number(sector.value).toFixed(0)
      );
    },
    legendDisplay: false,
    legendPercentace: true
  };
  partCountChartOptions = {
    core: ChartCore.JS,
    orientation: BarChartOrientation.VERTICAL,
    labelFunction: (sector, data) => {
      return sector.label + ': ' + sector.value;
    },
    legendDisplay: false,
    legendPercentace: true
  };
  pluginsSettings = {
    datalabels: {
      anchor: 'end',
      align: 'top',
      clamp: true,
      formatter: (value, context) =>  {
        return value;
      }
    }
  };

  total: number;

  constructor(
    private itemHttp: HttpItemsService,
    private filterService: FilterHandlerService,
    private czechNumberPipe: CzechNumberFormatPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.itemHttp.getTotalItemsCount().subscribe( total => {
      this.total = total.body;
    });
    this.prepareSumData();
    this.prepareFieldSumData();
    this.prepareFieldCountData();
    this.prepareCityPartCountData();
    this.prepareCityPartSumData();
    this.getFrontCurrentlyRealized();
  }

  onFieldSumChartClick(data) {
    this.router.navigate(['statistiky']);
    this.filterService.populateFilterByNameAndValue('oblast', data.optionId);
  }

  onFieldCountChartClick($event) {
    this.router.navigate(['statistiky']);
    this.filterService.populateFilterByNameAndValue('oblast', $event.optionId);
  }

  private getFrontCurrentlyRealized() {
    this.itemHttp.getFrontCurrentlyRealized().subscribe( result => {
      this.top5 = result.body;
    });
  }

  private prepareSumData() {
    this.itemHttp.getTotalSumGraphData().subscribe( result => {
      this.sumData.data = [
        {
          label: 'Dotace (' + this.czechNumberPipe.transform(result.body.grant.toFixed(0)) + ' Kč)',
          value: result.body.grant,
          color: '#386641'
        },
        {
          label: 'Spoluúčast (' + this.czechNumberPipe.transform(result.body.participation.toFixed(0)) + ' Kč)',
          value: result.body.participation,
          color: '#6A994E'
        }
      ];
      this.sumData.ready = true;
    });
  }

  private prepareFieldSumData() {
    this.itemHttp.getSumsByFieldsGraphData().subscribe( result => {
      const tempDataArr = [];
      result.body.forEach( (item, key) => {
        tempDataArr.push({
          label: item.name + ' (' + this.czechNumberPipe.transform((item.grant + item.budget).toFixed(0)) + ' Kč)',
          value: item.grant + item.budget,
          color: item.color,
          data: {optionId: item.fieldId}
        });
        this.fieldSumData.groups.push(item.name);
      });
      this.fieldSumData.data = tempDataArr;
      console.log(this.fieldSumData);
      this.fieldSumData.ready = true;
    });
  }

  private prepareFieldCountData() {
    this.itemHttp.getCountsByFieldsGraphData().subscribe( result => {
      result.body.forEach( (item, key) => {
        this.fieldCountData.data.push({
          label: item.name + ' (' + item.count + ')',
          value: item.count,
          color: item.color,
          data: {optionId: item.fieldId}
        });
        this.fieldCountData.groups.push(item.name);
      });
      this.fieldCountData.ready = true;
    });
  }

  private prepareCityPartSumData() {
    this.itemHttp.getSumsByCityPartsGraphData().subscribe( result => {
      const grant = {label: 'Dotace', values: [], color: '#49473e'};
      const budget = {label: 'Spoluúčast', values: [], color: []};
      result.body.forEach( (item) => {
        grant.values.push(item.grant);
        budget.values.push(item.budget);
        budget.color.push(item.color);
        this.cityPartSumData.groups.push(item.name);
      });
      this.cityPartSumData.data.push(grant, budget);
      this.cityPartSumData.ready = true;
    });
  }

  private prepareCityPartCountData() {
    this.itemHttp.getCountsByCityPartsGraphData().subscribe( result => {
      const colors = [];
      const values = [];
      result.body.forEach( (item, key) => {
        colors.push(item.color);
        values.push(item.count);
        this.cityPartCountData.groups.push(item.name);
      });
      this.cityPartCountData.data.push(
        {label: 'Městké části', values, color: colors }
      );
      this.cityPartCountData.ready = true;
    });
  }
}
